import PropTypes from 'prop-types'
import { Box, Paper } from '@mui/material'

import Loader from '../views/Loader'

import styles from '../views/ShippingDetail/styles'

const DesktopLayout = ({ isLoading, basicInfo, children }) => {
  return (
    <Box>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {basicInfo}
          <Paper elevation={1} sx={styles.paper}>
            {children}
          </Paper>
        </>
      )}
    </Box>
  )
}

DesktopLayout.propTypes = {
  isLoading: PropTypes.bool,
  basicInfo: PropTypes.node,
  children: PropTypes.node,
}

export default DesktopLayout
